import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bikeModel'
})
export class BikeModelPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value.startsWith("26")){
      // return "Atom"
      return "atom-icon.png";
    }else{
      // return "Pro/Trainer"
      return "pt-icon.png";
    }
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/bike-model.pipe.ts